// extracted by mini-css-extract-plugin
export var baseButton = "_p1-0";
export var controlsArrowKeys = "_p1-1";
export var controlsResetButton = "_p1-2";
export var lightGameButton = "_p1-4 _p1-0";
export var playAgainButton = "_p1-5 _p1-0";
export var startGameButton = "_p1-3 _p1-0";